import { spinnerShow, spinnerClose } from './spinner';

document.addEventListener('DOMContentLoaded', () => {
    const form = document.getElementById('report-submit-form') as HTMLFormElement | null;
    const spinner = document.getElementById('report-download-spinner') as HTMLElement | null;
    if (!form || !spinner) return;

    form.addEventListener('submit', async (e) => {
        e.preventDefault();
        if (!form.reportValidity()) return;
        spinnerShow(spinner);

        try {
            const response = await fetch(form.action, {
                method: 'POST',
                body: new FormData(form)
            });

            const contentType = response.headers.get('Content-Type') ?? '';
            if (contentType.includes('text/html')) {
                // Server returned validation errors — write the page back so they display normally
                const html = await response.text();
                document.open();
                document.write(html);
                document.close();
                return;
            }

            const disposition = response.headers.get('Content-Disposition') ?? '';
            const filename = parseFilename(disposition) ?? 'report.xls';

            const blob = await response.blob();
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            a.click();
            URL.revokeObjectURL(url);
        } finally {
            spinnerClose(spinner);
        }
    });
});

function parseFilename(disposition: string): string | null {
    // RFC 5987 encoding takes precedence
    const rfc5987 = disposition.match(/filename\*=UTF-8''([^;\s]+)/i);
    if (rfc5987) return decodeURIComponent(rfc5987[1]);

    const basic = disposition.match(/filename="?([^";\n]+)"?/i);
    if (basic) return basic[1].trim();

    return null;
}
